import React from "react";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Boton from "../boton/Boton";
import Error from "../generales/Error";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

const Formulario = ({ registroUsuarios, setRegistroUsuarios }) => {
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const lowercaseRegex = /(?=.*[a-z])/;
  const uppercaseRegex = /(?=.*[A-Z])/;
  const numericRegex = /(?=.*[0-9])/;
  const charactersRegex = /[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/;

  const nuevoUsuarioSchema = Yup.object().shape({
    email: Yup.string()
      .email("Correo electrónico No válido")
      .required("El correo electrónico es obligatorio"),
    password: Yup.string()
      .required("La contraseña es obligatoria")
      .matches(lowercaseRegex, "Debe contener al menos una minúscula")
      .matches(uppercaseRegex, "Debe contener al menos una mayúscula")
      .matches(numericRegex, "Debe contener al menos un número")
      .matches(charactersRegex, "Debe contener al menos un caracter especial")
      .min(6, "La contraseña debe tener mínimo 6 caracteres")
      .max(20, "La contraseña debe tener máximo 20 caracteres"),
    confirmPassword: Yup.string()
      .required("Este campo es obligatorio")
      .oneOf([Yup.ref("password"), null], "Las contraseñas No coinciden"),
  });

  const handleSubmit = async (valores) => {
    //POST
    try {
      const url = "https://mymoney5.herokuapp.com/auth/signup";
      //'http://localhost:4000/usuarios'

      const { status, data } = await axios.post(url, valores);
      console.log(data);
      if (status === 200) {

        console.log("Usuario registrado");
      }

      navigate("/");
    } catch (error) {
      console.log(error);
      setError(true);
      return;
    }
    setError(false);
  };

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        confirmPassword: "",
      }}
      onSubmit={async (values, { resetForm }) => {
        await handleSubmit(values);

        resetForm();
      }}
      validationSchema={nuevoUsuarioSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="email">Correo electrónico</label>
              <Field
                id="email"
                type="email"
                placeholder="Correo electrónico"
                name="email"
              />
              {errors.email && touched.email ? (
                <Error>{errors.email}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="password">Contraseña</label>
              <Field
                id="password"
                type="password"
                placeholder="Contraseña"
                name="password"
              />
              {errors.password && touched.password ? (
                <Error>{errors.password}</Error>
              ) : null}
            </div>
            <div className="formulario-input">
              <label htmlFor="confirmPassword">Confirma tu contraseña</label>
              <Field
                id="confirmPassword"
                type="Password"
                placeholder="Confirma tu contraseña"
                name="confirmPassword"
              />
              {errors.confirmPassword && touched.confirmPassword ? (
                <Error>{errors.confirmPassword}</Error>
              ) : null}
            </div>
            <Boton>Registrarme</Boton>
            {error && (
              <div className="formulario-error">
                <p>
                  El correo electrónico que ingresaste ya está registrado.
                  Intenta con uno distinto.
                </p>
              </div>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default Formulario;
